import React from 'react';
import { C as Chip } from './Chip-BoKhEDVA.js';
import './tslib.es6-DN65qNZS.js';
import { I as Icon } from './Icon-8KKXFsxm.js';
import { a as ComboboxContext } from './ComboboxProvider-DdsdhWRT.js';

function ComboboxTrigger({ label = "Select", selected, }) {
    const { handleClose, open, setOpen } = React.useContext(ComboboxContext);
    const hasSelection = selected.length;
    const selectedLabel = selected.map(option => option.label).join(", ");
    return (React.createElement(Chip, { variation: hasSelection ? "base" : "subtle", label: hasSelection ? selectedLabel : "", ariaLabel: label, heading: label, onClick: () => {
            if (open) {
                handleClose();
            }
            else {
                setOpen(true);
            }
        }, role: "combobox" }, !hasSelection && (React.createElement(Chip.Suffix, null,
        React.createElement(Icon, { name: "add", size: "small" })))));
}

export { ComboboxTrigger as C };
